module.exports = __webpack_public_path__ + "img/Comic04-5.2465db40.png";